import {serviceApiHostName} from "../../endpoint";
import {defaultHeaders} from "../../headers";

export const servicesSearch = async (filter) => {
  try {
    const result = await fetch(`${serviceApiHostName}/client/service/search`, {
      method: "POST",
      headers: {
        ...defaultHeaders,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      body: JSON.stringify(filter),
    });
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (error) {
    return {
      hasSuccess: false,
      data: error.message,
    };
  }
};
